import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip
} from '@mui/material';

const UserManagmentList = ({adminUsers,setDialogOpen,setUserForUpdate}) => {

    const UserTableHeader = () => {
        return (
            <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                <TableRow>
                    <TableCell>Email Address</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Username</TableCell>
                    <TableCell>Email Verified</TableCell>
                    <TableCell>Confirmation Status</TableCell>
                    <TableCell>Status</TableCell>
                </TableRow>
            </TableHead>
        );
    }

    const UserTableBody = () => {
        return (
            <TableBody>
                 {Array.isArray(adminUsers) && adminUsers?.map((user, idx) => 
                   (<UserTableBodyItem key={idx} user={user} idx={idx}/>)
                )}
            </TableBody>
        );
    }

    const UserTableBodyItem = ({user, idx}) => {
        return (
            <TableRow key={idx}  onClick={() => {
                console.log("clicked")
                setUserForUpdate(user);
                setDialogOpen(true);
            }}>
                        <TableCell>{user?.email}</TableCell>
                        <TableCell>{user?.role}</TableCell>
                        <TableCell>{user?.username}</TableCell>
                        <TableCell>
                            <Chip
                                label={user?.emailVerified ? 'Yes' : 'No'}
                                color={user?.emailVerified ? 'success' : 'error'}
                                size="small"
                            />
                        </TableCell>
                        <TableCell>
                            {user?.userStatus === 'CONFIRMED' ? (
                                <Chip label={user?.userStatus} color="success" size="small" />
                            ) : (
                                <Chip label={user?.userStatus} color="primary" size="small" />
                            )}
                        </TableCell>
                        <TableCell>
                            <Chip
                                label={user?.enabled === true ? 'Enable':'Disable'}
                                color={user?.enabled === true ? 'success' : 'primary'}
                                size="small"
                            />
                        </TableCell>
                    </TableRow>
        );
    }

    const UserTableContainor = () => {
        return (
            <TableContainer component={Paper}>
                <Table>
                    <UserTableHeader />
                    <UserTableBody adminUsers={adminUsers}/>
                </Table>
            </TableContainer>
        );
    }

    return (adminUsers && <UserTableContainor />);
}

export default UserManagmentList;